import GestaltLogo from "./GestaltLogo";
import EsyaButton from "./EsyaButton";

const inputClass =
  "w-full rounded-lg border border-slate-200 bg-white px-4 py-3 text-base text-[#292929] outline-none transition placeholder:text-slate-400 focus:border-primary focus:ring-2 focus:ring-primary/30";

const trustItems = [
  "HIPAA-ready access controls",
  "Unified patient and revenue workflows",
  "Role-based operating dashboards",
];

export default function LoginPage() {
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <main className="min-h-screen bg-[#f6f6f6] font-sans text-[#292929]">
      <div className="mx-auto grid min-h-screen max-w-7xl grid-cols-1 lg:grid-cols-[1.05fr_0.95fr]">
        <section className="relative overflow-hidden bg-secondary px-6 py-8 text-white sm:px-10 lg:flex lg:flex-col lg:justify-between lg:px-12">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,221,0,0.22),transparent_28%),radial-gradient(circle_at_78%_18%,rgba(20,184,166,0.22),transparent_30%),linear-gradient(135deg,rgba(15,23,42,0.96),rgba(15,23,42,0.86))]" />
          <div className="relative z-10">
            <a
              href="/"
              className="inline-flex rounded-xl bg-white/95 px-4 py-3 shadow-lg shadow-black/15"
              aria-label="Gestalt home"
            >
              <GestaltLogo variant="default" />
            </a>
          </div>

          <div className="relative z-10 mt-20 max-w-xl lg:mt-0">
            <p className="mb-5 inline-flex rounded-full border border-primary/40 bg-primary/10 px-4 py-2 text-sm font-semibold text-primary">
              eSya secure workspace
            </p>
            <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
              Sign in to keep care operations moving.
            </h1>
            <p className="mt-6 max-w-lg text-lg leading-8 text-slate-200">
              Access scheduling, billing, patient movement, and executive visibility from one healthcare operations layer.
            </p>
          </div>

          <div className="relative z-10 mt-14 grid gap-3 sm:grid-cols-3 lg:mt-0">
            {trustItems.map((item) => (
              <div key={item} className="rounded-2xl border border-white/10 bg-white/10 p-4 backdrop-blur">
                <div className="mb-3 h-1.5 w-10 rounded-full bg-primary" />
                <p className="text-sm font-semibold leading-5 text-white/90">{item}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="flex items-center justify-center px-6 py-12 sm:px-10 lg:px-12">
          <div className="w-full max-w-md">
            <div className="rounded-[28px] border border-white bg-white p-6 shadow-2xl shadow-slate-900/10 sm:p-8">
              <div className="mb-8">
                <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[#a67502]">Welcome back</p>
                <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-[#292929]">
                  Login to your account
                </h2>
                <p className="mt-3 text-base leading-7 text-[#525252]">
                  Use your organization credentials to continue.
                </p>
              </div>

              <form className="space-y-5" onSubmit={handleSubmit}>
                <label className="block">
                  <span className="mb-2 block text-sm font-semibold text-[#292929]">Work email</span>
                  <input className={inputClass} type="email" autoComplete="email" placeholder="name@hospital.com" />
                </label>

                <label className="block">
                  <span className="mb-2 block text-sm font-semibold text-[#292929]">Password</span>
                  <input className={inputClass} type="password" autoComplete="current-password" placeholder="Enter password" />
                </label>

                <div className="flex items-center justify-between gap-4 text-sm">
                  <label className="inline-flex items-center gap-2 text-[#525252]">
                    <input
                      type="checkbox"
                      className="size-4 rounded border-slate-300 text-primary focus:ring-primary"
                    />
                    Remember me
                  </label>
                  <a className="font-semibold text-[#a67502] hover:text-secondary" href="#reset-password">
                    Forgot password?
                  </a>
                </div>

                <EsyaButton className="w-full" iconRight type="submit">
                  Login
                </EsyaButton>

                <EsyaButton as="a" className="w-full" href="/" size="medium" variant="secondary">
                  Back to website
                </EsyaButton>
              </form>
            </div>

            <p className="mt-6 text-center text-sm text-[#525252]">
              Need access?{" "}
              <a href="/#demo-form" className="font-semibold text-[#a67502] hover:text-secondary">
                Connect with us
              </a>
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
